document.addEventListener('DOMContentLoaded', function () {
  // Move every modal overlay to be a direct child of <body>.
  // This prevents position:fixed from breaking when a parent element
  // (e.g. a page-transition wrapper using CSS transform) creates its
  // own containing block, which otherwise makes the modal render
  // outside the visible viewport on mobile.
  document.querySelectorAll('[data-airlines-overlay]').forEach(function (overlay) {
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
  });

  document.querySelectorAll('[data-airlines-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-airlines-open');
      var modal = document.getElementById(id);
      if (modal) {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-airlines-overlay]').forEach(function (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        overlay.hidden = true;
        document.body.style.overflow = '';
      }
    });

    var closeBtn = overlay.querySelector('[data-airlines-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        overlay.hidden = true;
        document.body.style.overflow = '';
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-airlines-overlay]').forEach(function (overlay) {
        if (!overlay.hidden) {
          overlay.hidden = true;
          document.body.style.overflow = '';
        }
      });
    }
  });
});